(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function drawerFrom(el) {
    return (el && el.closest && el.closest('[data-menu-drawer]')) || qs('[data-menu-drawer]');
  }

  function slideClosed(panel) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.classList.add('is-closing');
    panel.setAttribute('aria-hidden', 'true');
  }

  function setMenuToggle(open) {
    var btn = qs('[data-menu-open]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  function openMenu() {
    var drawer = qs('[data-menu-drawer]');
    var backdrop = qs('[data-menu-backdrop]');
    if (!drawer || !backdrop) return;
    backdrop.hidden = false;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-menu-open');
    setMenuToggle(true);
  }

  function closeAllPanels(drawer) {
    qsa('[data-menu-panel]', drawer).forEach(function (panel) {
      panel.classList.remove('is-open', 'is-closing');
      panel.setAttribute('aria-hidden', 'true');
    });
    qsa('[data-menu-open-panel]', drawer).forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    drawer.classList.remove('has-sub');
  }

  function closeMenu() {
    var drawer = qs('[data-menu-drawer]');
    var backdrop = qs('[data-menu-backdrop]');
    if (!drawer) return;
    closeAllPanels(drawer);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-menu-open');
    setMenuToggle(false);
    if (backdrop) {
      backdrop.classList.remove('is-visible');
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) backdrop.hidden = true;
      }, 280);
    }
  }

  function closeTopPanel(drawer) {
    if (!drawer) return;
    var open = qsa('[data-menu-panel].is-open', drawer);
    var top = open[open.length - 1];
    if (!top) return;
    slideClosed(top);
    if (open.length <= 1) {
      drawer.classList.remove('has-sub');
      qsa('[data-menu-root] [data-menu-open-panel]', drawer).forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function openPanel(opener) {
    var drawer = drawerFrom(opener);
    var id = opener.getAttribute('data-menu-open-panel');
    if (!drawer || !id) return;
    var panel = qs('[data-menu-panel="' + id + '"]', drawer);
    if (!panel) return;
    if (opener.closest('[data-menu-root]')) {
      qsa('[data-menu-panel]', drawer).forEach(function (item) {
        if (item === panel) return;
        slideClosed(item);
      });
    }
    panel.classList.remove('is-closing');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    drawer.classList.add('has-sub');
    opener.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target;
      if (!el) return;
      if (el.nodeType !== 1) el = el.parentElement;
      if (!el || typeof el.closest !== 'function') return;

      var opener = el.closest('[data-menu-open-panel]');
      if (opener) {
        e.preventDefault();
        openPanel(opener);
        return;
      }
      if (el.closest('[data-menu-open]')) {
        e.preventDefault();
        var drawer = qs('[data-menu-drawer]');
        if (drawer && drawer.classList.contains('is-open')) closeMenu();
        else openMenu();
        return;
      }
      if (el.closest('[data-menu-backdrop]')) {
        closeMenu();
        return;
      }
      if (el.closest('[data-menu-close-panel]')) {
        e.preventDefault();
        closeTopPanel(drawerFrom(el));
      }
    },
    true
  );

  document.addEventListener('transitionend', function (e) {
    var panel = e.target;
    if (!panel || !panel.classList || !panel.classList.contains('mobile-menu-panel')) return;
    if (e.propertyName && e.propertyName !== 'transform') return;
    panel.classList.remove('is-closing');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = qs('[data-menu-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (drawer.classList.contains('has-sub')) closeTopPanel(drawer);
    else closeMenu();
  });

  window.MobileMenu = { close: closeMenu };
})();
